import React, {useState} from 'react'
import { useSelector } from 'react-redux';
import { Button, Input, TextArea, Modal, Select } from '../DesignSystem'

import './index.scss'

export default function ConfirmationModal({ show, onClose, onConfirmation, message, title, defaultStatus }) {

  const { currentCase} = useSelector((state) => state.crm);

  const [reason, setReason] = useState('')
  const [amount, setAmount] = useState('')
  const [parc, setParc] = useState('')
  const [newState, setNewState] = useState(defaultStatus ? String(defaultStatus) : '0')
  const [newStatePagamento, setNewStatePagamento] = useState('0')

  const caseMode = getCaseMode()
  
  function getCaseMode(){
    // console.log("ID ====> ", currentCase?.case?.cases_types_id)
    if(!currentCase?.case?.cases_types_id) return null;
    if(currentCase.case.cases_types_id === 1) return 'FINANCEIRO';
    if(currentCase.case.cases_types_id === 2) return 'JUDICIAL';
  }

  const options = [
    { value: 0, label: "Selecione o novo status" },
    // { value: 11, label: "Aguardando contato" },
    { value: 12, label: "Aguardando assinaturas" },
    { value: 15, label: "Aguardando assinatura e pagamento" },
    { value: 14, label: "Aguardando pagamento" },
    { value: 17, label: "Arquivado" },
    { value: 13, label: "Concluido" },
    { value: 16, label: "Encerrado" },
    { value: 10, label: "Negociando " },
  ]
  
  const optionsOpPagamento = [
    { value: 0, label: "Selecione o novo status" },
    // { value: 11, label: "Aguardando contato" },
    { value: 1, label: "Á vista" },
    { value: 2, label: "Parcelado" },
  ]
  async function handleConfirmation() {
    if(newStatePagamento === '1'){
      await onConfirmation(Number(newState),1, newStatePagamento, moneyMask(amount))
    }else{
      await onConfirmation(Number(newState),parc, newStatePagamento, moneyMask(amount))
    }

    
    setParc('')
    setAmount('')
    setNewStatePagamento('0')
    onClose()
  }
  function format(value){
    const formattedAmount = (value).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  
    return formattedAmount;

  }

  function verifyForm(){
    if(newStatePagamento === 0)
      return true;

    if(newStatePagamento == 2 && (parc.replace(/[^\d]/g, '')/100) == 0)
      return true;
    
    return (amount.replace(/[^\d]/g, '')/100) == 0;
  }


  function moneyMask() {
    if (!amount || amount === '') return 'R$ 0,00';
    
    const onlyNumbers = amount.replace(/[^\d]/g, '');
  
    const formattedAmount = (Number(onlyNumbers) / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
    return formattedAmount;
  }

  function number() {
    if (!parc || parc === '') return '0';
    
    const onlyNumbers = parc.replace(/[^\d]/g, '');
  
    const formattedAmount = Number(onlyNumbers) 
  
    return formattedAmount;
  }

  function renderChildren() {
    return (
      <div className='modal-confirmation__container'>
          {caseMode}
          <p className='modal-confirmation__content'>
            {message}
          </p>
        {
        caseMode === 'JUDICIAL' &&
           
          <>
            {!defaultStatus && 
            <Select 
            value={newState} 
            label='Selecione o status' 
            options={options}
            onChange={state => {setNewState(state)}}
            />}
            {
            newState === '16' && 
            <>
      
              <hr/>
            <Select 
            value={newStatePagamento} 
            label='Selecione forma de pagamento' 
            options={optionsOpPagamento}
            onChange={state => {
              setNewStatePagamento(state);
            }}
            />

              {newStatePagamento === '2' 
                ? 
                <Input
                label='Numero da Parcela'
                value={number(parc)}
                onChange={setParc}/>
                : ""
              }
              <Input
              label='Valor'
              value={moneyMask(amount)}
              onChange={setAmount}/>

              <hr/>

              Total: {newStatePagamento === '2' ? format(parc *  Number(amount.replace(/[^\d]/g, ''))/100) : moneyMask(amount)}
            </>
            }
          </>
        }

        
        
      </div>
    )
  }

  function renderFooter() {
    return (
      <div style={{ gap: '8px' }}>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          contained
          disabled={ caseMode === 'JUDICIAL' && (newState === '0' || (newState === '16' && verifyForm())) }
          onClick={handleConfirmation}
        >
          Confirmar 
        </Button>
      </div>
    )
  }

  return (
    <Modal
      show={show}
      title={title}
      children={renderChildren()}
      renderFooter={renderFooter()}
      onClose={onClose}
    />
  )
}